import React from 'react'

const Works = () => {
  return (
<div name='work' className='w-full md:h-screen text-gray-300 bg-[#0a192f]'>
  
</div>
    )
}

export default Works